export default() => [
  {
    text: i18n.t("Increasing Deterioration"),
    class: "trendsIncreasingDeterioration",
  },
  {
    text: i18n.t("Slowing Deterioration"),
    class: "trendsSlowingDeterioration",
  },
  {
    text: i18n.t("Warning Signs"),
    class: "trendsWarningSigns",
  },
  {
    text: i18n.t("Bouncing Back"),
    class: "trendsBouncingBack",
  },
  {
    text: i18n.t("Slowing Improvement"),
    class: "trendsSlowingImprovement",
  },
  {
    text: i18n.t("Increasing Improvement"),
    class: "trendsIncreasingImprovement",
  },
];
